// 登嘉楼州球场数据
// Terengganu Golf Courses

export const TERENGGANU_COURSES = {
  "Awana_Kijal_Golf_Beach_&_Spa_Resort": {
    shortName: "AKGBSR",
    fullName: "Awana Kijal Golf Beach & Spa Resort",
    location: ["Kijal", "Terengganu", "Malaysia"],
    pars: [4,4,5,3,4,4,3,4,5, 4,4,3,5,3,5,4,4,4],
    index: [13,7,3,15,1,5,17,9,10, 4,4,3,5,3,5,4,4,4]
  },

  "GREEN_ACRES_GOLF_AND_COUNTRY_RESORT": {
    shortName: "GAGCR",
    fullName: "Green Acres Golf & Country Resort",
    location: ["Kuala Terengganu", "Terengganu", "Malaysia"],
    pars: [4,5,3,4,4,4,4,3,5, 4,4,4,3,5,4,3,4,5],
    index: [11,17,15,5,7,13,1,3,9, 18,16,8,10,2,4,6,12,14]
  },

  "KELAB_GOLF_BUKIT_BESI": {
    shortName: "KGBB",
    fullName: "Kelab Golf Bukit Besi",
    location: ["Bukit Besi", "Terengganu", "Malaysia"],
    pars: [4,5,4,3,4,3,4,5,4, 4,5,4,3,4,4,3,5,4],
    index: [15,3,1,17,11,13,9,5,7, 8,2,14,18,6,12,16,4,10]
  },

  "KELAB_GOLF_DESA_DUNGUN": {
    shortName: "KGDD",
    fullName: "Kelab Golf Desa Dungun",
    location: ["Kuala Dungun", "Terengganu", "Malaysia"],
    pars: [4,5,4,3,4,4,4,3,5, 4,5,5,4,4,3,4,3,4],
    index: [5,1,13,17,9,11,7,15,3, 12,10,4,2,14,18,8,16,6]
  },

  "KELAB_GOLF_&_REKREASI_PETRONAS": {
    shortName: "KGRP",
    fullName: "Kelab Golf & Rekreasi Petronas",
    location: ["Kerteh", "Terengganu", "Malaysia"],
    pars: [4,4,5,4,3,5,4,3,4, 4,4,5,4,3,5,4,3,4],
    index: [11,17,1,5,15,3,13,9,7, 8,12,6,4,18,2,16,10,14]
  },

  "KELAB_REKREASI_PUGK": {
    shortName: "KRPUGK",
    fullName: "Kelab Rekreasi Pangkalan Udara Gong Kedak",
    location: ["Jerteh", "Terengganu", "Malaysia"],
    pars: [4,4,5,4,3,3,4,4,5],
    index: [6,5,1,4,9,8,7,3,2]
  },

  "KUALA_TERENGGANU_GOLF_RESORT": {
    shortName: "KTGR",
    fullName: "Kuala Terengganu Golf Resort",
    location: ["Kuala Terengganu", "Terengganu", "Malaysia"],
    pars: [5,4,4,3,4,4,5,3,4, 5,3,4,4,5,4,4,3,4],
    index: [13,15,1,11,3,5,7,17,9, 2,18,6,12,4,10,8,16,14]
  },

  "Royal_Terengganu_Golf_Club": {
    shortName: "RTGC",
    fullName: "Royal Terengganu Golf Club",
    location: ["Kuala Terengganu", "Terengganu", "Malaysia"],
    pars: [4,5,4,3,4,4,5,4,3, 4,5,3,4,4,4,5,4,3],
    index: [1,7,9,15,5,17,3,11,13, 4,6,10,8,12,18,2,16,14]
  }
};

export default TERENGGANU_COURSES;
